import React, { useState, useMemo } from 'react';
import { SECTORS, normSector } from '../data/sectors';
import './SectorCombobox.css';

/**
 * 🏷️ Combobox secteur — saisie libre + suggestions de métiers.
 * Réutilisé à l'Onboarding et dans Settings (source unique : data/sectors.js).
 * Un métier hors liste reste valide : le backend l'estime via l'IA (partagée).
 *
 * Props : value (string), onChange(value:string), label?, placeholder?, hint?
 */
export default function SectorCombobox({
  value = '',
  onChange,
  label = "Secteur d'activité",
  placeholder = 'Commence à taper… (coiffure, garage, marketing…)',
  hint,
}) {
  const [focus, setFocus] = useState(false);
  const v = value || '';

  const suggestions = useMemo(() => {
    const q = normSector(v.trim());
    if (!q) return SECTORS;                                    // tout, la liste défile
    return SECTORS.filter(s => normSector(s).includes(q));     // tous les matchs
  }, [v]);

  const isKnown = SECTORS.some(s => normSector(s) === normSector(v.trim()));
  const showList = focus && (suggestions.length > 0 || v.trim().length >= 2);

  return (
    <div className="input-group scb">
      {label && <label className="input-label">{label}</label>}
      <div className="input-wrap">
        <input
          className="input-field"
          type="text"
          value={v}
          placeholder={placeholder}
          onChange={e => onChange(e.target.value)}
          onFocus={() => setFocus(true)}
          onBlur={() => setTimeout(() => setFocus(false), 180)}
        />
      </div>

      {showList && (
        <div className="scb-list">
          {suggestions.map(s => (
            <button
              key={s}
              type="button"
              className="scb-opt"
              onMouseDown={() => { onChange(s); setFocus(false); }}
            >
              {s}
            </button>
          ))}
          {!isKnown && v.trim().length >= 2 && (
            <button
              type="button"
              className="scb-opt scb-custom"
              onMouseDown={() => setFocus(false)}
            >
              ➕ Utiliser « {v.trim()} » — le génie l'analysera pour toi
            </button>
          )}
        </div>
      )}

      {hint && !showList && <p className="input-hint">{hint}</p>}
      {!hint && v && isKnown && !showList && (
        <p className="input-hint scb-ok">✓ Secteur reconnu</p>
      )}
    </div>
  );
}
